// extracted by mini-css-extract-plugin
export default {"wrap":"TextResult_wrap__1VKbx","title":"TextResult_title__x1-sQ"};